import { observer } from 'mobx-react-lite'
import { FullPageWrapper } from 'shared/ui'
import { useBroadcastPageContext } from 'pages/broadcasts/context/broadcastsPageContext'
import { BroadcastList } from 'pages/broadcasts/ui/BroacastList'

export const AllBroadcasts = observer(() => {
  const storeBroadcastPage = useBroadcastPageContext()

  return (
    <FullPageWrapper>
      <BroadcastList
        storeProps={{
          type: 'all',
          pageLayoutStore: storeBroadcastPage.pageLayoutStore,
        }}
      />
    </FullPageWrapper>
  )
})
